'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

exports.default = getEndpoint;

var _querystring = require('querystring');

var _querystring2 = _interopRequireDefault(_querystring);

var _config = require('../config');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * [getEndpoint description]
 * @param   {[type]} provider [description]
 * @param   {[type]} path     [description]
 * @param   {[type]} [queries]  [description]
 * @returns {[type]}          [description]
 */
function getEndpoint(provider, path, queries) {
    var baseUrl = (0, _config.getBaseUrl)(provider);
    var endpoint = (baseUrl + '/' + path).replace(/([^:]\/)\/+/g, '$1');

    if (queries && (0, _keys2.default)(queries).length > 0) {
        var queryStr = _querystring2.default.stringify(queries);
        return endpoint + '?' + queryStr;
    }
    return endpoint;
}
//# sourceMappingURL=getEndpoint.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@wh/data-provider/dist/main/get-endpoint/getEndpoint.js
// module id = 447
// module chunks = 0